import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ja from './ja'
import en from './en'
import zh from './zh'
import zh_hant from './zh-hant'
import ko from './ko'

Vue.use(VueI18n)

export enum Locale {
  JA = 'ja',
  JP = 'ja',
  EN = 'en',
  ZH = 'zh',
  'ZH-HANS' = 'zh',
  'ZH-HANT' = 'zh-hant',
  KO = 'ko',
  KR = 'ko',
}

export default new VueI18n({
  locale: 'en',
  messages: {
    ja,
    en,
    zh,
    'zh-hant': zh_hant,
    ko
  },
  fallbackLocale: 'en',
  silentFallbackWarn: true,
})
